"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const qs_1 = __importDefault(require("qs"));
const API = {
    listLog: '/blockpass_console/v1/systemlogs/users',
    listLogAdmin: '/blockpass_console/v1/systemlogs/queries',
};
class ActivityLog {
    constructor(httpClient, config) {
        this._httpClient = httpClient;
        this._baseURL = config.baseURL;
    }
    async getListLog(filter, page, isAdmin = false) {
        const query = {
            page,
            ...filter,
        };
        const url = `${isAdmin ? API.listLogAdmin : API.listLog}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url, { baseURL: this._baseURL });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = lodash_1.default.map(resBody, '_id');
        data.entities = {
            activityLogs: lodash_1.default.keyBy(resBody, '_id'),
        };
        return data;
    }
}
exports.default = ActivityLog;
